<template>
	<div class="video-progress-container">
		<time class="text-medium" v-if="showPlayerProgress">{{ formattedCurrentTime }} / {{ formattedDuration }}</time>
		<div class="progress-bar-container">
			<div class="progress-bar-bg">
				<div class="progress-bar-fill" :style="{ width: progressPercent + '%' }" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
	defineProps<{
		currentTime: number;
		videoDuration: number;
		showPlayerProgress?: boolean;
	}>(),
	{
		currentTime: 0,
		videoDuration: 1,
		showPlayerProgress: true,
	}
);

function formatTime(seconds: number): string {
	const mins = Math.floor(seconds / 60);
	const secs = Math.floor(seconds % 60);
	return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

const formattedCurrentTime = computed(() => formatTime(props.currentTime));
const formattedDuration = computed(() => formatTime(props.videoDuration));

const progressPercent = computed(() => {
	const safeTime = Math.min(props.currentTime, props.videoDuration);
	return (safeTime / props.videoDuration) * 100;
});
</script>

<style scoped>
.video-progress-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 8px;
	padding: 24px 0px 24px 16px;
	width: 100%;
}

.progress-bar-container {
	flex: 1;
	min-width: 100px;
	max-width: 100%;
}

.progress-bar-bg {
	background-color: #353a42;
	height: 4px;
	border-radius: 2px;
	overflow: hidden;
	width: 100%;
	position: relative;
}

.progress-bar-fill {
	background-color: #fbc500;
	height: 100%;
	width: 0%;
	transition: width 0.25s linear;
}
</style>
